export default "__VITE_ASSET__Dw2GhkIB__"